/* eslint-disable object-shorthand */
import axios, { AxiosResponse } from "axios";
import { ApiErrorHandler } from "../../../../errorHandler";
import {
  CreateProductState,
} from "../../../shared/interfaces/components/createproduct.interface";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import apiClient from "../../shared/api/apiClient";

export const postCreateProduct = (payload: CreateProductState) => {
  // Object created with the keywords that BE/apigee expects.
  const object = {
    name: payload.name,
    desc: payload.desc,
    appUrl: payload.appUrl,
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/product/`;
  return apiClient
    .post(URL, object)
    .then((response: AxiosResponse) => response)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};
